import useAppDispatch from "../../hooks/use-app-dispatch";
import useAppSelector from "../../hooks/use-app-selector";
import { clearAnswer } from "../../app/slices/question-slice";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useIsSuperAdmin } from "../../hooks/use-is-super-admin";

import closeDrawer from "../../assets/close-drawer.svg";
import askLink from "../../assets/ask-link.svg";
import documentLibraryLink from "../../assets/document-library-link.svg";
import settingsLink from "../../assets/settings-link.svg";
import { DocumentIcon, ShieldCheckIcon } from "@heroicons/react/24/outline";

interface Props {
    onClose: () => void;
}

export default (props: Props) => {
    const dispatch = useAppDispatch();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const { questionAsking } = useAppSelector((store) => store.question);
    const isAsking = Boolean(questionAsking);
    const { isSuperAdmin } = useIsSuperAdmin();

    const handleAskClick = () => {
        props.onClose();

        if (pathname === "/ask") {
            if (isAsking) return;
            dispatch(clearAnswer());
        } else {
            if (!isAsking) dispatch(clearAnswer());
            navigate("/ask");
        }
    };

    return (
        <div className="flex flex-col">
            <div className="flex flex-row justify-end cursor-pointer">
                <img
                    className="p-3"
                    onClick={props.onClose}
                    src={closeDrawer}
                    alt=""
                />
            </div>

            <div className="flex flex-col gap-3">
                <div
                    className="flex flex-row items-center px-3 gap-3"
                    onClick={handleAskClick}
                >
                    <img src={askLink} alt="" />

                    <p>ASK</p>
                </div>

                <Link to="/document-library" onClick={props.onClose}>
                    <div className="flex flex-row items-center px-3 gap-3">
                        <img src={documentLibraryLink} alt="" />

                        <p>History</p>
                    </div>
                </Link>

                <Link to="/files" onClick={props.onClose}>
                    <div className="flex flex-row items-center px-3 gap-3">
                        <DocumentIcon className="w-6 h-6 text-lite-grey" />

                        <p>Files</p>
                    </div>
                </Link>

                <Link to="/settings" onClick={props.onClose}>
                    <div className="flex flex-row items-center px-3 gap-3">
                        <img src={settingsLink} alt="" />

                        <p>Settings</p>
                    </div>
                </Link>

                {isSuperAdmin && (
                    <Link to="/super-admin" onClick={props.onClose}>
                        <div className="flex flex-row items-center px-3 gap-3">
                            <ShieldCheckIcon className="w-6 h-6 text-lite-grey" />

                            <p>Super Admin</p>
                        </div>
                    </Link>
                )}
            </div>
        </div>
    );
};
